import { Theme } from "@mui/material/styles";

// eslint-disable-next-line no-unused-vars
export default function Chip(_: Theme) {
  return {
    MuiChip: {},
  };
}
